import React, { ReactNode } from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { documentsByKey } from 'constants/common';
import { getVendorContactRoleName } from 'utils/formatters';

import { FormSummaryInfo } from '../FormSummaryInfo';
import { FinanceProgramForm } from '../../../../../schema';

interface Props {
  financeProgramFormValues: FinanceProgramForm['program'];
}

interface RelatedUser {
  id: string;
  dynamicsContactId: string | null;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber: string | null;
  mobilePhoneNumber: string | null;
  mugshot: string | null;
  availability: string | null;
  vendorContactRole: string;
  title: string | null;
  accountId: string;
  status: string;
}

export const SubmissionSettingsSummaryPart = ({ financeProgramFormValues: program }: Props) => {
  const formData = program.first.submissionSettings.excludedDocuments;
  const autoSubmitUserId = program.first.submissionSettings.autoSubmitUserProfileId;

  const relatedUsers: RelatedUser[] = useSelector((state: any) => state.relatedUsers || []);

  const selectedUser = autoSubmitUserId ? relatedUsers.find(user => user.id === autoSubmitUserId) : null;

  const autoSubmitRoleDisplay = selectedUser
    ? `${selectedUser.fullName} (${getVendorContactRoleName(selectedUser.vendorContactRole)})`
    : null;

  const renderData: Record<string, ReactNode> = {
    'Document Types Excluded': formData.length
      ? formData.map(s => get(documentsByKey, `[${s}].text`)).join(', ')
      : 'Global configuration applied',
    ...(autoSubmitRoleDisplay && {
      'Auto-Submit Role': autoSubmitRoleDisplay,
    }),
  };

  return <FormSummaryInfo data={renderData} />;
};
